<template>
  <div class="row">
    <div class="col-md-12">
      <div class="rental-card-wide rental-card-loading boxed-widget--clean boxed-widget--mobile">
        <i class="fa fa-spinner fa-pulse"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adivare-rental-card-loading',
}
</script>
